<template>
    <div class="l-wrap-user">
        <div class="l-constrained l-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-12">
                        <h1>Employer Job Board Profile</h1>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <el-form label-position="top">
                            <el-form-item label="About us" style="margin-bottom: 0px;"></el-form-item>
                            
                            <froala :tag="'textarea'" :config="froalaConfig" v-model="data.about_us"></froala>

                            <el-form-item label="Logo">
                                <el-upload
                                        :action="uploadUrl"
                                        list-type="picture-card"
                                        :on-preview="handlePictureCardPreview"
                                        :on-remove="x => handleRemove('logo', x)"
                                        :on-success="x => imageUploaded('logo', x)"
                                        :file-list="data.images.logo"
                                        :class="{ hideUpload: hideLogoUpload }"
                                        >
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>

                            <el-form-item label="Hero Image (min 1348 x 320px)">
                                <el-upload
                                        :action="uploadUrl"
                                        list-type="picture-card"
                                        :on-preview="handlePictureCardPreview"
                                        :on-remove="x => handleRemove('hero', x)"
                                        :on-success="x => imageUploaded('hero', x)"
                                        :file-list="data.images.hero"
                                        :class="{ hideUpload: hideHeroUpload }">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>

                            <el-form-item label="Images (min 300 x 300px)">
                                <el-upload
                                        :multiple="true"
                                        :action="uploadUrl"
                                        list-type="picture-card"
                                        :on-preview="handlePictureCardPreview"
                                        :on-remove="x => handleRemove('images', x)"
                                        :on-success="(response, file, fileList) => imageUploaded('images', response, file, fileList)"
                                        :file-list="data.images.images">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            
                            <el-button type="primary" @click="saveChanges">Save Changes</el-button>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            employerId: { type: Number, required: true },
        },
        data() {
            return {
                uploadUrl: this.$root.imageUploadUrl,
                data: {
                    about_us: '',
                    images: {
                        logo: [],
                        hero: [],
                        images: [],
                    }
                },
                froalaConfig: {
                    key: 'CA4D4A2D3E1D2tA6B4B3A1C7D1G2E1E4A3oa2Pe2HTPYh1RNc2E1KDc1==',
                    events: {
                        'froalaEditor.initialized': function () {
                            console.log('initialized')
                        }
                    },
                    enter: $.FroalaEditor.ENTER_BR,
                    toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', '|', 'color', 'paragraphFormat', 'align', 'formatUL', 'html'],
                    htmlRemoveTags: ['script', 'style', 'base'],
                    pasteDeniedTags: ['script', 'style', 'base', 'div', 'span', 'dl', 'dt', 'dd'],
                    pasteDeniedAttrs: ['class', 'id', 'style', 'dir'],

                    // always clean on Word paste (not giving a choice)
                    wordPasteModal: false,
                    wordPasteKeepFormatting: false
                }
            }
        },
        computed: {
            hideLogoUpload: function () {
                return this.data.images.logo.length > 0;
            },
            hideHeroUpload: function () {
                return this.data.images.hero.length > 0;
            },
        },
        methods: {
            handleRemove(type, file, fileList) {
                this.data.images[type] = _.filter(this.data.images[type], t => t.url !== file.url);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            imageUploaded(type, response, file, fileList) {
                let url = response;

                let image = {
                    name: '',
                    url: url
                };

                if(fileList){
                    let index = _.indexOf(fileList, file);
                    fileList.splice( index, 1, image);
                    this.data.images[type] = fileList;
                }
                else{
                    this.data.images[type].push(image);
                }
            },
            loadData() {
                axios.get(url(`admin/jobboard-employer-profile/${this.employerId}/data`))
                    .then(response => {
                        this.data = response.data;
                    });
            },
            saveChanges() {
                let $this = this;
                return axios.post(url(`admin/jobboard-employer-profile/${this.employerId}/update`), {
                        about_us: this.data.about_us,
                        images: this.data.images
                    })
                    .then(response => {
                        $this.$message.success(response.data.status);
                        window.location.href = response.data.url;
                    });
            }
        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style>
    .el-upload-list--picture-card .el-upload-list__item-thumbnail {
        width: initial;
        height: initial;
        max-width: 100%;
        max-height: 100%;
    }
    .el-upload__input {
        display: none !important;
    }
    .hideUpload > div {
        display: none;
    }    
    .fr-box {
        border-bottom: 1px solid gray;
        margin-bottom: 22px;
    }
    .fr-box .fr-view p {
        margin: 0;
    }
</style>
